module.exports = __webpack_public_path__ + "static/media/best-dinner.1dab870a.svg";